export default {
  location: {
    'en-US': [
      {
        id: 'locationName',
        label: 'Location Name',
        placeholder: 'Type a name here...',
        type: 'text',
        value: '',
        disabled: true
      },
      {
        id: 'locationDescription',
        label: 'Location Description',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: '',
        disabled: true
      }
    ],
    'en-CA': [
      {
        id: 'locationName',
        label: 'Location Name',
        placeholder: 'Type a name here...',
        type: 'text',
        value: ''
      },
      {
        id: 'locationDescription',
        label: 'Location Description',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: ''
      }
    ],
    'fr-CA': [
      {
        id: 'locationName',
        label: 'Location Name',
        placeholder: 'Type a name here...',
        type: 'text',
        value: ''
      },
      {
        id: 'locationDescription',
        label: 'Location Description',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: ''
      }
    ],
    'es-MX': [
      {
        id: 'locationName',
        label: 'Location Name',
        placeholder: 'Type a name here...',
        type: 'text',
        value: ''
      },
      {
        id: 'locationDescription',
        label: 'Location Description',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: ''
      }
    ]
  },
  evse: {
    'en-US': [
      {
        id: 'evseName',
        label: 'EVSE Name',
        placeholder: 'Type a name here...',
        type: 'text',
        value: '',
        disabled: true
      },
      {
        id: 'evseDescription',
        label: 'EVSE Description',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: '',
        disabled: true
      }
    ],
    'en-CA': [
      {
        id: 'evseName',
        label: 'EVSE Name',
        placeholder: 'Type a name here...',
        type: 'text',
        value: ''
      },
      {
        id: 'evseDescription',
        label: 'EVSE Description',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: ''
      }
    ],
    'fr-CA': [
      {
        id: 'evseName',
        label: 'EVSE Name',
        placeholder: 'Type a name here...',
        type: 'text',
        value: ''
      },
      {
        id: 'evseDescription',
        label: 'EVSE Description',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: ''
      }
    ],
    'es-MX': [
      {
        id: 'evseName',
        label: 'EVSE Name',
        placeholder: 'Type a name here...',
        type: 'text',
        value: ''
      },
      {
        id: 'evseDescription',
        label: 'EVSE Description',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: ''
      }
    ]
  },
  pricePlan: {
    'en-US': [
      {
        id: 'pricePlanName',
        label: 'Price Plan Name',
        placeholder: 'Type a name here...',
        type: 'text',
        value: '',
        disabled: true
      },
      {
        id: 'pricePlanDescription',
        label: 'Price Plan Description',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: '',
        disabled: true
      }
    ],
    'en-CA': [
      {
        id: 'pricePlanName',
        label: 'Price Plan Name',
        placeholder: 'Type a name here...',
        type: 'text',
        value: ''
      },
      {
        id: 'pricePlanDescription',
        label: 'Price Plan Description',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: ''
      }
    ],
    'fr-CA': [
      {
        id: 'pricePlanName',
        label: 'Price Plan Name',
        placeholder: 'Type a name here...',
        type: 'text',
        value: ''
      },
      {
        id: 'pricePlanDescription',
        label: 'Price Plan Description',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: ''
      }
    ],
    'es-MX': [
      {
        id: 'pricePlanName',
        label: 'Price Plan Name',
        placeholder: 'Type a name here...',
        type: 'text',
        value: ''
      },
      {
        id: 'pricePlanDescription',
        label: 'Price Plan Description',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: ''
      }
    ]
  },
  subscriptionPlan: {
    'en-US': [
      {
        id: 'subscriptionPlanName',
        label: 'Subscription Plan Name',
        placeholder: 'Type a name here...',
        type: 'text',
        value: '',
        disabled: true,
        maxlength: 40
      },
      {
        id: 'subscriptionPlanDescription',
        label: 'Subscription Plan Description',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: '',
        disabled: true,
        maxlength: 255
      },
      {
        id: 'subscriptionPlanTitle',
        label: 'Subscription Plan Title',
        placeholder: 'Type a brief title here...',
        type: 'text',
        value: '',
        maxlength: 30
      },
      {
        id: 'subscriptionPlanDetailsHeader',
        label: 'Subscription Plan Details Header',
        placeholder: 'Type a brief title here...',
        type: 'text',
        value: '',
        maxlength: 50
      },
      {
        id: 'subscriptionPlanFullDetails',
        label: 'Subscription Plan Full Details',
        placeholder: 'Type a brief title here...',
        type: 'textarea',
        value: '',
        maxlength: 650
      },
      {
        id: 'subscriptionPlanTagDetails',
        label: 'Subscription Plan Tag Details',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: '',
        maxlength: 150
      },
      {
        id: 'subscriptionPlanBenefits',
        label: 'Subscription Plan Benefits',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: '',
        maxlength: 350
      },
      {
        id: 'subscriptionPlanSessionDescription',
        label: 'Subscription Plan Session Description',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: '',
        maxlength: 140
      },
      {
        id: 'subscriptionPlanThankYouText',
        label: 'Subscription Plan Thank You Text',
        placeholder: 'Type a brief thank you text here...',
        type: 'text',
        value: '',
        maxlength: 80
      },
      {
        id: 'subscriptionPlanDisclosure',
        label: 'Disclosure',
        type: 'text',
        value: ''
      },
      {
        id: 'subscriptionPlanLogo',
        label: 'Logo Image',
        type: 'file',
        acceptedFiles: 'image/png,image/jpeg,.png,.jpg',
        width: 70,
        height: 70,
        note: 'File type: PNG or JPG; 70 x 70 px',
        value: null
      },
      {
        id: 'subscriptionPlanOemVehicleImage',
        label: 'OEM Vehicle Image',
        type: 'file',
        acceptedFiles: 'image/png,image/jpeg,.png,.jpg',
        width: 520,
        height: 200,
        note: 'File type: PNG or JPG; 520 x 200 px',
        value: null
      }
    ],
    'en-CA': [
      {
        id: 'subscriptionPlanName',
        label: 'Subscription Plan Name',
        placeholder: 'Type a name here...',
        type: 'text',
        value: '',
        maxlength: 40
      },
      {
        id: 'subscriptionPlanDescription',
        label: 'Subscription Plan Description',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: '',
        maxlength: 255
      },
      {
        id: 'subscriptionPlanTitle',
        label: 'Subscription Plan Title',
        placeholder: 'Type a brief title here...',
        type: 'text',
        value: '',
        maxlength: 30
      },
      {
        id: 'subscriptionPlanDetailsHeader',
        label: 'Subscription Plan Details Header',
        placeholder: 'Type a brief title here...',
        type: 'text',
        value: '',
        maxlength: 50
      },
      {
        id: 'subscriptionPlanFullDetails',
        label: 'Subscription Plan Full Details',
        placeholder: 'Type a brief title here...',
        type: 'textarea',
        value: '',
        maxlength: 650
      },
      {
        id: 'subscriptionPlanTagDetails',
        label: 'Subscription Plan Tag Details',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: '',
        maxlength: 150
      },
      {
        id: 'subscriptionPlanBenefits',
        label: 'Subscription Plan Benefits',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: '',
        maxlength: 350
      },
      {
        id: 'subscriptionPlanSessionDescription',
        label: 'Subscription Plan Session Description',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: '',
        maxlength: 140
      },
      {
        id: 'subscriptionPlanThankYouText',
        label: 'Subscription Plan Thank You Text',
        placeholder: 'Type a brief thank you text here...',
        type: 'text',
        value: '',
        maxlength: 80
      },
      {
        id: 'subscriptionPlanDisclosure',
        label: 'Disclosure',
        type: 'text',
        value: ''
      },
      {
        id: 'subscriptionPlanLogo',
        label: 'Logo Image',
        type: 'file',
        acceptedFiles: 'image/png,image/jpeg,.png,.jpg',
        width: 70,
        height: 70,
        note: 'File type: PNG or JPG; 70 x 70 px',
        value: null
      },
      {
        id: 'subscriptionPlanOemVehicleImage',
        label: 'OEM Vehicle Image',
        type: 'file',
        acceptedFiles: 'image/png,image/jpeg,.png,.jpg',
        width: 520,
        height: 200,
        note: 'File type: PNG or JPG; 520 x 200 px',
        value: null
      }
    ],
    'fr-CA': [
      {
        id: 'subscriptionPlanName',
        label: 'Subscription Plan Name',
        placeholder: 'Type a name here...',
        type: 'text',
        value: '',
        maxlength: 40
      },
      {
        id: 'subscriptionPlanDescription',
        label: 'Subscription Plan Description',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: '',
        maxlength: 255
      },
      {
        id: 'subscriptionPlanTitle',
        label: 'Subscription Plan Title',
        placeholder: 'Type a brief title here...',
        type: 'text',
        value: '',
        maxlength: 30
      },
      {
        id: 'subscriptionPlanDetailsHeader',
        label: 'Subscription Plan Details Header',
        placeholder: 'Type a brief title here...',
        type: 'text',
        value: '',
        maxlength: 50
      },
      {
        id: 'subscriptionPlanFullDetails',
        label: 'Subscription Plan Full Details',
        placeholder: 'Type a brief title here...',
        type: 'textarea',
        value: '',
        maxlength: 650
      },
      {
        id: 'subscriptionPlanTagDetails',
        label: 'Subscription Plan Tag Details',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: '',
        maxlength: 150
      },
      {
        id: 'subscriptionPlanBenefits',
        label: 'Subscription Plan Benefits',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: '',
        maxlength: 350
      },
      {
        id: 'subscriptionPlanSessionDescription',
        label: 'Subscription Plan Session Description',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: '',
        maxlength: 140
      },
      {
        id: 'subscriptionPlanThankYouText',
        label: 'Subscription Plan Thank You Text',
        placeholder: 'Type a brief thank you text here...',
        type: 'text',
        value: '',
        maxlength: 80
      },
      {
        id: 'subscriptionPlanDisclosure',
        label: 'Disclosure',
        type: 'text',
        value: ''
      },
      {
        id: 'subscriptionPlanLogo',
        label: 'Logo Image',
        type: 'file',
        acceptedFiles: 'image/png,image/jpeg,.png,.jpg',
        width: 70,
        height: 70,
        note: 'File type: PNG or JPG; 70 x 70 px',
        value: null
      },
      {
        id: 'subscriptionPlanOemVehicleImage',
        label: 'OEM Vehicle Image',
        type: 'file',
        acceptedFiles: 'image/png,image/jpeg,.png,.jpg',
        width: 520,
        height: 200,
        note: 'File type: PNG or JPG; 520 x 200 px',
        value: null
      }
    ],
    'es-MX': [
      {
        id: 'subscriptionPlanName',
        label: 'Subscription Plan Name',
        placeholder: 'Type a name here...',
        type: 'text',
        value: '',
        maxlength: 40
      },
      {
        id: 'subscriptionPlanDescription',
        label: 'Subscription Plan Description',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: '',
        maxlength: 255
      },
      {
        id: 'subscriptionPlanTitle',
        label: 'Subscription Plan Title',
        placeholder: 'Type a brief title here...',
        type: 'text',
        value: '',
        maxlength: 30
      },
      {
        id: 'subscriptionPlanDetailsHeader',
        label: 'Subscription Plan Details Header',
        placeholder: 'Type a brief title here...',
        type: 'text',
        value: '',
        maxlength: 50
      },
      {
        id: 'subscriptionPlanFullDetails',
        label: 'Subscription Plan Full Details',
        placeholder: 'Type a brief title here...',
        type: 'textarea',
        value: '',
        maxlength: 650
      },
      {
        id: 'subscriptionPlanTagDetails',
        label: 'Subscription Plan Tag Details',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: '',
        maxlength: 150
      },
      {
        id: 'subscriptionPlanBenefits',
        label: 'Subscription Plan Benefits',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: '',
        maxlength: 350
      },
      {
        id: 'subscriptionPlanSessionDescription',
        label: 'Subscription Plan Session Description',
        placeholder: 'Type a brief description here...',
        type: 'textarea',
        value: '',
        maxlength: 140
      },
      {
        id: 'subscriptionPlanThankYouText',
        label: 'Subscription Plan Thank You Text',
        placeholder: 'Type a brief thank you text here...',
        type: 'text',
        value: '',
        maxlength: 80
      },
      {
        id: 'subscriptionPlanDisclosure',
        label: 'Disclosure',
        type: 'text',
        value: ''
      },
      {
        id: 'subscriptionPlanLogo',
        label: 'Logo Image',
        type: 'file',
        acceptedFiles: 'image/png,image/jpeg,.png,.jpg',
        width: 70,
        height: 70,
        note: 'File type: PNG or JPG; 70 x 70 px',
        value: null
      },
      {
        id: 'subscriptionPlanOemVehicleImage',
        label: 'OEM Vehicle Image',
        type: 'file',
        acceptedFiles: 'image/png,image/jpeg,.png,.jpg',
        width: 520,
        height: 200,
        note: 'File type: PNG or JPG; 520 x 200 px',
        value: null
      }
    ]
  }
}